<template>
  <content-list-page content-type="page"/>
</template>

<script>
import ContentListPage from "../../components/dashboard/Content/ContentListPage.vue";

export default {
  name: "Product",
  components: {ContentListPage},
};
</script>
